module.exports = __webpack_public_path__ + "img/hr-diesel-locomotive-mask-5.9918c641.png";